import React from "react";
import { useNavigate } from "react-router-dom";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import ArrowBack from "@mui/icons-material/ArrowBack";

interface BackButtonProps extends IconButtonProps {
  fallbackPath?: string;
}

const BackButton = ({ fallbackPath = "/", ...props }: BackButtonProps) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    // Check if there is a history stack to go back to.
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      // Fallback to the provided path and replace the current history entry.
      navigate(fallbackPath, { replace: true });
    }
  };

  return (
    <IconButton
      onClick={handleGoBack}
      aria-label="go back"
      {...props}
      sx={{
        border: "1px solid",
        borderColor: "grey.300",
        backgroundColor: "grey.50",
        color: "text.secondary",
        "&:hover": {
          backgroundColor: "grey.200",
        },
        // This line ensures that any `sx` props passed from the parent
        // component can override these default styles.
        ...props.sx,
      }}
    >
      <ArrowBack />
    </IconButton>
  );
};

export default BackButton;